import { mux_environment_token, storefront_api_prefix } from 'shared/var'
import fetchy from 'shared/fetchy'
import player from './player'

const api_deprecated_fetch = fetchy(storefront_api_prefix + `/p/`)

export default async(target, props) => {
	target.classList.add(`video-js`)

	const { id } = props
	let { mux_playback_id, title, thumbnail_timecode_seconds, duration_seconds } = props

	try {
		if (!mux_playback_id) {
			({ title, mux_playback_id, thumbnail_timecode_seconds, duration_seconds } = await api_deprecated_fetch(`video/${ id }`, { method: `GET` }))
		}

		const video_player = player({
			target,
			mux_playback_id,
			thumbnail_timecode_seconds,
			duration_seconds,
			title,
			mux_data: {
				env_key: mux_environment_token,
				video_title: title,
				player_name: `T.Rex Player`,
				player_version: `1.1.0`,
				video_id: id,
			},
		})

		const goto_time = seconds => {
			video_player.currentTime(seconds)
			video_player.poster(`https://image.mux.com/${ mux_playback_id }/thumbnail.jpg?time=${ seconds }`)

			const url = new URL(window.location)

			url.hash = `#video_${ id }`
			url.searchParams.set(`t`, seconds)

			history.replaceState({}, ``, url)
		}

		window[`video_${ id }_goto_time`] = goto_time

		const url = new URL(window.location)

		if (url.hash === `#video_${ id }` && url.searchParams.get(`t`)) {
			goto_time(url.searchParams.get(`t`))
		}
	} catch (e) {
		console.error(e)

		const error_node = document.createElement(`div`)
		error_node.classList.add(`video-error`)
		error_node.innerText = `Video playback error: ${ typeof e === `object` ? JSON.stringify(e) : e }`

		target.parentNode.insertBefore(error_node, target)
		target.classList.add(`error`)
	}
}
